define(
    'NetSuite.SuiteCommCPQ.Main', [
        'NetSuite.SuiteCommCPQ.Main.View', 'NetSuite.SuiteCommCPQ.Main.View.Head', 'NetSuite.SuiteCommCPQ.Main.View.Sku', 'NetSuite.SuiteCommCPQ.Main.Model',
        'NetSuite.SuiteCommCPQ.Main.Debug', 'NetSuite.SuiteCommCPQ.Main.Configuration',
        'NetSuite.SuiteCommCPQ.CartHandler', 'NetSuite.SuiteCommCPQ.Main.Core',
        'NetSuite.SuiteCommCPQ.Main.View.QuickAdd'
    ],
    function(
        MainView, ViewHead, ViewSku, Model, Debugger, Configuration, CartHandler, Core, ViewQuickAdd
    ) {
    'use strict';
    return {
        mountToApp: function mountToApp(container) {
            var environment = container.getComponent('Environment');
            if (environment && !environment.isPageGenerator()) {
                Configuration.set('pageGen', false);
                Configuration._init();
                Debugger._init();
                Core._init();
                var enableExt = Configuration.get('isConfigEnabled'),
                    cpqBtnTemplateContainer = Configuration.get('templateContainer') || 'Product.Price', // put child view here (target value of the div's "data-view" property)
                    cpqBtnTemplateContainerArray;
                if (!enableExt)
                    return;
                cpqBtnTemplateContainerArray = parseTplContainers(cpqBtnTemplateContainer);
                // using the 'Layout' component we add a new child view inside the 'Header' existing view
                // (there will be a DOM element with the HTML attribute data-view="Header.Logo")
                // more documentation of the Extensibility API in
                // https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
                /** @type {LayoutComponent} */
                var layout = container.getComponent('Layout');
                if (layout) {
                    var model = new Model();
                    model._init();
                    var viewHead = new ViewHead({
                        container: container
                    });
                    viewHead._init();
                    var viewSku = new ViewSku({
                        container: container
                    });
                    var viewQuickAdd = new ViewQuickAdd({
                        container: container
                    });
                    // Configure & Edit Config buttons
                    var mainViews = [];
                    cpqBtnTemplateContainerArray.forEach(function (cont, idx) {
                        var view = new MainView({
                            container: container,
                            model: model
                        });
                        view._init();
                        mainViews.push(view);
                        layout.addChildView(cont, function addChildView() {
                            return view;
                        });
                    });
                    model.fetch().done(function doneFetch() {
                        mainViews.forEach(function (view) {
                            view.loaded();
                        });
                    });
                    // Header.Logo CSS
                    layout.addChildView('Header.Logo', function addChildView() {
                        return viewHead;
                    });
                    // Product.Sku block: PDP styling
                    layout.addChildView('Product.Sku', function addChildView() {
                        return viewSku;
                    });
                    // Configure button in QuickAdd
                    layout.addChildView('QuickAddView', function addChildView() {
                        return viewQuickAdd;
                    });
                
                    var cart = container.getComponent ('Cart');
                    if (cart) {
                        var cartMode = Configuration.get('cartMode');
                        var mode = {
                            allowSeparateDelete: cartMode == "AllowChangeDelete",
                            allowUpdate: ["AllowChangeDelete", "AllowChange"].includes(cartMode)
                        };
                        var cartHandler = new CartHandler (cart, layout, mode, function() { return !Core.isUpdatingCart(); });
                        cartHandler.initialize();
                    }
                }
            } else {
                Configuration.set('pageGen', true);
            }
        }
    };
    //
    function parseTplContainers(contString) {
        var contArray = contString ? contString.split(',') : ['Product.Price'], out = [];
        contArray.forEach(function (cont) {
            if (cont && cont.length) {
                out.push(cont);
            }
        });
        return out;
    }
});
